var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconZoomIn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 20.3L18 16.6C19.2 15.1 20 13.1 20 11C20 6 16 2 11 2C6 2 2 6 2 11C2 16 6 20 11 20C13.1 20 15.1 19.3 16.6 18L20.3 21.7C20.5 21.9 20.8 22 21 22C21.2 22 21.5 21.9 21.7 21.7C22.1 21.3 22.1 20.7 21.7 20.3ZM4 11C4 7.1 7.1 4 11 4C14.9 4 18 7.1 18 11C18 12.8 17.3 14.5 16.2 15.7C16.1 15.7 16 15.8 15.9 15.9C15.8 16 15.8 16.1 15.7 16.2C14.5 17.3 12.8 18 11 18C7.1 18 4 14.9 4 11ZM14 10H12V8C12 7.4 11.6 7 11 7C10.4 7 10 7.4 10 8V10H8C7.4 10 7 10.4 7 11C7 11.6 7.4 12 8 12H10V14C10 14.6 10.4 15 11 15C11.6 15 12 14.6 12 14V12H14C14.6 12 15 11.6 15 11C15 10.4 14.6 10 14 10Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconZoomIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconZoomIn.d7599eb2350f8a2925147928ee8d85b4.svg";